import { ReactNode } from 'react';
import { InformationBadgeWrapper } from './style';
import InfoIcon from 'crono-fe-common/icons/Info-Icon';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';

type IProps = Omit<{ title?: ReactNode }, 'children'>;

const InformationBadge = ({ title }: IProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <InformationBadgeWrapper className="info-icon">
          <InfoIcon size={16} />
        </InformationBadgeWrapper>
      </TooltipTrigger>
      <TooltipContent className="z-35002">{title}</TooltipContent>
    </Tooltip>
  );
};

export default InformationBadge;
